export const siteSettings = {
  name: "Octagonal Pro",
  link: "https://octagonalpros.live",
  email: "support@octagonalpros.live",
  appLink: "https://app.octagonalpros.live",
};
